import React from 'react';
import { KitStatus, getKitStatusColor, getKitStatusDescription } from '../../models/customerOverview';
import { KitStatusContainer, ColorIndicator } from '../../styles/styled-components/Customer/Customer';
import i18next from 'i18next';

type KitStatusIndicatorProps = {
  status: KitStatus;
  reportReady: boolean;
  isReportRelesed?: boolean;
};

export class KitStatusIndicator extends React.PureComponent<KitStatusIndicatorProps> {

  getKitResult = (status: KitStatus, reportReady: boolean, isReportRelesed?: boolean) => {
    if (reportReady) {
      return `${i18next.t('cmp.overview.reportReady')}`;
    }
    switch (status) {
      case 'rejected':
        return `${i18next.t('cmp.overview.rejected')}`;
      case 'lab':
        return `${i18next.t('cmp.overview.sampleAtLabNotRegistered')}`;
      case 'activated':
        return `${i18next.t('cmp.overview.sampleRegisteredNotAtLab')}`;
      case 'ready':
        return `${i18next.t('cmp.overview.sampleAtLabRegistered')}`;
    }

    return getKitStatusDescription(status);
  }
  render() {
    const { status, reportReady, isReportRelesed } = this.props;
    const color = getKitStatusColor(status, reportReady);
    const kitResult = this.getKitResult(status, reportReady, isReportRelesed);

    return <KitStatusContainer className="KitStatusIndicator">
      <ColorIndicator
        className="circle"
        style={{
          backgroundColor: color,
          color: `${color}aa`,
        }} />
      <div>
        {
          kitResult
        }
      </div>
    </KitStatusContainer>;
  }
}
